<template>
  <div class="forget-password-modular">
    <div class="header-modular">
      <headerInfo  ref="headerModular" :number="cartNum"></headerInfo>
    </div>
    <div class="logo-modular">
      <img class="logo-img" src="../assets/public/logo.png" alt="" />
      <div class="forget-text">{{ pageTextArr[0] }}</div>
      <div class="address-text">{{ pageTextArr[1] }}</div>
      <div class="form-msg">
        <div class="login-input marginTop75">
          <span class="title">
            <span class="red-color">*</span>
            {{ pageTextArr[2] }}</span>
          <input type="password" class="account padding20" v-model="newPassword" />
        </div>
        <div class="login-input marginTop75">
          <span class="title">
            <span class="red-color">*</span>
            {{ pageTextArr[3] }}</span>
          <input type="password" class="account padding20" v-model="confirmPassword" />
        </div>
        <div>
          <button class="login-button marginTop45" @click="clickforgetPassword()">{{ pageTextArr[4] }}</button>
        </div>
      </div>
    </div>
    <footerInfo></footerInfo>
  </div>
</template>
  
<script>
import headerInfo from "../components/public/headerInfo";
import footerInfo from "../components/public/footerInfo";

export default {
  components: {
    headerInfo,
    footerInfo,
  },
  data() {
    return {
      cartNum: 0,
      email: "",
      newPassword: '',
      confirmPassword: '',
      pageTextArr:[
        "创建新密码",
        "您在每次登录时，都需要提供此密码。",
        "新密码",
        "确认密码",
        "保存更改并登录",
        "请输入新密码！",
        "请输入确认新密码！",
        "请保持新密码与确认密码保持一致！",
        "修改成功",
        "修改失败"
      ]
    };
  },
  created() {
    this.email = this.$route.query.email
  },
  methods: {
    /**
     * 创建新密码
     */
    clickforgetPassword() {
      let that = this;
      if (that.newPassword == '') {
        this.$message({ title: "警告", message: this.pageTextArr[5], type: "error" });
        return
      } else if (that.confirmPassword == '') {
        this.$message({ title: "警告", message: this.pageTextArr[6], type: "error" });
        return
      } else if (that.confirmPassword != that.confirmPassword) {
        this.$message({ title: "警告", message: this.pageTextArr[7], type: "error" });
        return
      } else {
        that.forgetPassword();
      }
    },
    
    /**
     * 忘记密码- 创建新密码
     */
    forgetPassword() {
      let that = this;
      let data = {
        email: that.email,
        new_password: that.newPassword,
        confirm_password: that.confirmPassword
      }
      this.$http.forgetPassword(
        data,
        (res) => {
          if (res.ret == 1) {
            this.$message.success(this.pageTextArr[8]);
            this.$router.push({
              path:  '/login'
            })
          } else {
            this.$message.error(this.pageTextArr[9]);
          }
        },
       (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    translateByArr(arr, callback, errCallBack) {
      let that = this;
      let data = {
        text: arr, //带翻译数组
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translateByArr(data, callback, errCallBack);
    },

    languageTranslateByArrs(arr){
      let that = this
      let newpagetextArr = []
      that.translateByArr(arr,res=>{
        console.log("res",res);
        res.data.forEach((item,index)=>{
          newpagetextArr.push(item.translation)
        })
        that.pageTextArr = newpagetextArr
      })
    },
  },
  mounted() {
    let that = this;
    that.languageTranslateByArrs(that.pageTextArr);

  }
};
</script>
<style scoped>
* {
  box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/view/creatNewPassword.vue